import { useState, useEffect, useRef } from 'react';
import { FaCheck, FaWindowClose } from 'react-icons/fa';
import { Image } from 'react-bootstrap';
import { SyncStatus } from '../../util/enum';
import { consultaStatusSincronizacao } from '../../services/api/SyncConvertConvenia';
import imgLoading from '../../assets/img/loading.gif';
import axios from 'axios';

const useSyncStatusConvenia = ( SyncStatusTipo ) => {
    const [statusSincronizacao, setStatusSincronizacao] = useState("");
    const [statusMessage, setStatusMessage] = useState({
        message: "",
        icon: null
    });

    const intervalRef = useRef(null);
    const controllerRef = useRef(new AbortController());

    const handleGetSyncStatus = async () => {
        try {
            const resp = await consultaStatusSincronizacao(SyncStatusTipo, { signal: controllerRef.current.signal });

            const rawStatus = resp.data.status;
            setStatusSincronizacao(rawStatus);

            if (rawStatus === SyncStatus.IN_PROGRESS) {
                setStatusMessage({
                    message: "Atualizando dados com o Convenia. Por favor, aguarde...",
                    icon: <Image width={25} height={25} src={imgLoading} />
                });
            } else if (rawStatus === SyncStatus.FAILED) {
                setStatusMessage({
                    message: "Erro durante o processo de sincronização.",
                    icon: <FaWindowClose />
                });
                clearInterval(intervalRef.current);
            } else {
                setStatusMessage({
                    message: "Dados atualizados com sucesso.",
                    icon: <FaCheck />
                });
                clearInterval(intervalRef.current);
            }

        } catch (err) {
            if (axios.isCancel(err)) {
                console.log('Requisição de status cancelada');
                return;
            }
            console.error('Erro ao consultar status:', err);
            setStatusSincronizacao(SyncStatus.FAILED);
            setStatusMessage({
                message: "Erro ao consultar status da sincronização.",
                icon: <FaWindowClose />
            });
            clearInterval(intervalRef.current);
        }
    };

    useEffect(() => {
        handleGetSyncStatus();
        intervalRef.current = setInterval(handleGetSyncStatus, 15000);

        return () => {
            clearInterval(intervalRef.current);
            controllerRef.current.abort();
        };
    }, []);

    const startSyncCheck = () => {
        handleGetSyncStatus();
        clearInterval(intervalRef.current);
        intervalRef.current = setInterval(handleGetSyncStatus, 15000);
    };

    return { statusSincronizacao, statusMessage, startSyncCheck };
};

export default useSyncStatusConvenia;